export enum TextSelectElementType {
  Button = 'button',
  Text = 'text',
}
